<script>
import VueRenderPlugin from "rete-vue-render-plugin";
import {actionType} from "@src/functions/reteEditor";

export default {
  components: {
    Socket: VueRenderPlugin.Socket
  },
  directives: {
    socket: {
      bind: function bind(el, binding, vnode) {
        vnode.context.bindSocket(el, binding.arg, binding.value);
      },
      update: function update(el, binding, vnode) {
        vnode.context.bindSocket(el, binding.arg, binding.value);
        if (binding.value.node.data && 'readInputSocket' in vnode.context)
          vnode.context.readInputSocket()
      }
    }
  },
  props: ['node', 'editor', 'bindSocket', 'bindControl'],
  data(){
    return {
      focus: false,
      nodeWidth: 256,
      nodeHeight: 90,
    }
  },
  mounted() {
    
    // console.log(this.node)

    this.editor.on('clearfocus', () => {
      this.focus = false
    })
    this.editor.on('nodefocus', ({node}) => {
      if (this.node.id === node.id) this.focus = true
    })
    
  },
  methods: {
    outputs() {
      return Array.from(this.node.outputs.values());
    },
    inputs() {
      return Array.from(this.node.inputs.values());
    },
    selected() {
      return this.editor.selected.contains(this.node) ? 'selected' : '';
    },
    getActionName(action) {
      return actionType[action] || 'Тип блока не задан'
    },
    onFocus(event) {
      if (this.focus || event.target.classList.contains('socket')) return
      this.editor.trigger('nodefocus', {node: this.node})
      this.focus = true
    },
    getIcon(action) {
      switch (action) {
        case 'call': return 'uil-outgoing-call'
        case 'audio_play': return 'uil-play'
        case 'speech_synthesis': return 'uil-volume'
        case 'audio_transcription': return 'uil-edit-alt'
        case 'intent': return 'uil-comment-verify'
        case 'goto': return 'uil-expand-from-corner'
        case 'set_variables': return 'uil-left-indent'
        case 'http_request': return 'uil-cloud-upload'
        case 'audio_record': return 'uil-microphone'
        case 'end_call': return 'uil-phone-slash'
        case 'message_send': return 'uil-comment-lines'
        case 'event_wait': return 'uil-sync'
        case 'call_redirect': return 'uil-arrow-random'
        default: return 'uil-phone-slash'
      }
    },
    getColor(action) {
      switch (action) {
        case 'call': return '#45B19F'
        case 'audio_play': return '#72AF9D'        
        case 'speech_synthesis': return '#32A0D4'
        case 'audio_transcription': return '#BAA1DD'
        case 'intent': return '#45B19F'
        case 'goto': return '#489DC2'
        case 'set_variables': return '#E49C74'
        case 'http_request': return '#489DC2'
        case 'audio_record': return '#EB9B6D'
        case 'end_call': return '#E26A4F'
        case 'ai_request': return '#000000'
        case 'message_send': return '#6D8EB9'
        case 'event_wait': return '#72AF9D'
        case 'call_redirect': return '#72AF9D'
        case 'digital_input': return '#72AF9D'
        default: return '#E26A4F'
      }
    }
  },
  nodeName: 'node',
}
</script>

<template>
  <div
      class="node"
      :class="[(focus || node.data.focus) && 'focus', !outputs().length && 'notOut', !inputs().length && 'notInput']"
      :style="`width: ${nodeWidth}px`"
      @click.capture="onFocus"
  >

    <div v-for="input in inputs()" :key="input.key" class="input">
      <Socket v-socket:input="input" type="input" :socket="input.socket"  />
    </div>

    <div class="head" >
      <h5>
        <i v-if="node.data.action !== 'set_variables' && node.data.action !== 'ai_request'  && node.data.action !== 'digital_input'" :class="'feather uil ' + getIcon(node.data.action)" :style="'font-size: 16px; margin-right: 5px; color: ' + getColor(node.data.action)"></i>
        <span v-if="node.data.action === 'set_variables'" :style="'font-size: 14px; font-weight: 700; margin-right: 5px; color: ' + getColor(node.data.action)">$x</span>
        <span v-if="node.data.action === 'ai_request'" :style="'font-size: 14px; font-weight: 700; margin-right: 5px; color: ' + getColor(node.data.action)">AI.</span>
        <span v-if="node.data.action === 'digital_input'" :style="'font-size: 14px; font-weight: 700; margin-right: 5px; color: ' + getColor(node.data.action)">123</span>

        {{ getActionName(node.data.action) }}
      </h5>
    </div>
    <p class="description">{{ node.data.description || "Описание узла отсутствует" }}</p>
    <p style="text-align: right; font-size: 11px; margin-top: 10px">ID: {{ node.id }} </p>
    <div class="outputs" :class="outputs().length > 1 ? 'extended' : ''">
      <div v-for="output in outputs()" :key="output.key" class="output">
        <p v-show="outputs().length > 1 && output.key === 'default'" class="action-description">Отказ</p>
        <p v-show="output.key === 'action'" class="action-description">Верно</p>
        <Socket v-socket:output="output" type="output" :socket="output.socket" />
      </div>
    </div>

  </div>
</template>

<style scoped>
p {
  margin-bottom: 0;
}

.node {
  padding: 0 15px 0 15px;
}

.node.notOut {
  padding-bottom: 15px;
}

.node.notInput {
  padding-top: 15px;
}

.title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.node{
  background: #ffffffc9;
  padding: 0 15px 0 15px;
  border-radius: 8px;
  box-shadow: #7c7c7c33 0 0 30px 0;
}

.head {
  display: flex;
  align-items: center;
  gap: 25px;
}

.head h5 {
  margin-top: 0;
  font-size: 16px;
}

.action-description {
  position: absolute;
  bottom: 7px;
}

.socket.input:hover, .socket.output:hover {
  transform: scale(2);
  opacity: 1;
  transition: all 0.2s cubic-bezier(.25, .1, .25, 1);
}

.outputs {
  display: flex;
  justify-content: space-around;
}

.outputs.extended {
  margin-top: 28px;
}

.output, .input {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.input {
  margin-top: unset;
  margin-bottom: 15px;
}


.socket.input, .socket.output {
  margin: unset !important;
  width: 9px;
  height: 9px;
  background: #9d9d9d;
  border: none;
  position: absolute;
}

.icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}

.icon.focus {
  filter: brightness(0.5);
}
</style>